import { mutateApi } from "src/utils/api/ApiMethods"

export const scanDockwaPayToken = ({ marinaSlug, code }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/dockwa_pay/tokens/scan`,
    method: "POST",
    data: {
      scanned_code: code,
    },
  })
}
